module.exports = __webpack_public_path__ + "static/media/Screenshot_64.37f305d2.png";